import { css } from 'styled-components'

import { PB97T } from '@h2/components/colors'
import { lists } from '@h2/components/mixins'
import { features } from '@h2/components/media'

const navLink = css`
  width: 100%;
  display: inline-flex;
  white-space: nowrap;
  flex-direction: column;
  align-items: center;
  padding: 6px 10px;
  background-color: ${PB97T};

  &:hover {
    text-decoration: none;
  }

  @media (${features.minWidth.laptop}) {
    background-color: white;

    &:hover {
      background-color: ${PB97T};
    }
  }
`
const navButton = css`
  font-size: unset;
  border: none;
  border-radius: 0;
  width: 100%;
  background-color: ${PB97T};

  @media (${features.minWidth.laptop}) {
    background-color: white;

    &:hover {
      background-color: ${PB97T};
    }
  }
`
const navList = css`
  &,
  > ul {
    ${lists};
    display: flex;

    > li {
      border: 1px solid white;
      border-right: none;

      button {
        ${navButton};
      }

      &:first-child {
        border-left: none;
      }
    }
  }
`
const subNavList = css`
  ${navList};
  width: 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: ${({ offset }) => (offset ? 'auto' : 0)};
  bottom: ${({ offset }) => offset ?? 'auto'};
  background-color: white;
`

export { navLink, navButton, navList, subNavList }
